import { PM_PROVIDERS } from 'common/constants/constants';
import useJiraEntities from './useJiraEntities';
import useShortcutEntities from './useShortcutEntities';
import useAzureBoardsEntities from './useAzureBoardsEntities/useAzureBoardsEntities';

const NO_PROVIDER_TYPE = 'NO_PROVIDER';
const mapSensorToUseEntities = {
  [PM_PROVIDERS.JIRA]: useJiraEntities,
  [PM_PROVIDERS.CLUBHOUSE]: useShortcutEntities,
  [PM_PROVIDERS.AZURE_BOARDS]: useAzureBoardsEntities,
  [NO_PROVIDER_TYPE]: () => ({
    data: [],
    loading: null,
    error: null
  })
};

const useProviderEntities = (sensorTypeId = NO_PROVIDER_TYPE, entityName) => {
  const useEntities = mapSensorToUseEntities[sensorTypeId];
  return useEntities(entityName);
};

export default useProviderEntities;
